import { render } from "./UnassignedClients.vue?vue&type=template&id=c10ce6f6&ts=true"
import script from "./UnassignedClients.vue?vue&type=script&lang=ts"
export * from "./UnassignedClients.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__